import React, { FunctionComponent } from "react";
import classNames from "classnames";
import * as styles from "./Typography.module.scss";
import { Colors } from "@helpers/Colors";

export type Variant =
  | "HERO"
  | "HEADER1"
  | "HEADER2"
  | "HEADER3"
  | "QUOTE"
  | "HEADER4"
  | "SUBTITLE"
  | "DESCRIPTION"
  | "BUTTON"
  | "SUBHEADERDESC"
  | "SUBHEADERDESCBOLD"
  | "BODY"
  | "CAPTION"
  | "FOOTER"
  | "FOOTERBOLD";

export type TypographyProps = {
  id?: string;
  variant?: Variant;
  color?: Colors;
  style?: React.CSSProperties;
  className?: string;
  center?: boolean;
  inline?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
  /** if true, use typograph for new layout system (default = false)*/
  newLayout?: boolean;
};

const Typography: FunctionComponent<TypographyProps> = ({
  id,
  variant = "BODY",
  color,
  style = {},
  className = "",
  children,
  center = false,
  inline = false,
  onClick,
  newLayout = false,
}) => {
  const getTag = () => {
    if (inline) {
      return "span";
    }
    switch (variant) {
      case "HEADER1":
      case "HEADER2":
      case "HEADER3":
      case "HEADER4":
      case "HERO":
      case "HEADER4":
        return "h1";
      case "SUBHEADERDESC":
      case "SUBHEADERDESCBOLD":
      case "SUBTITLE":
        return "h5";
      default:
        return "div";
    }
  };

  if (!inline && !variant) {
    variant = "BODY";
  }
  return React.createElement(getTag(), {
    className: classNames(className, {
      // If inline, inherit the variant unless otherwise specified.
      [styles[variant]]: !newLayout && (!inline || !!variant),
      [styles[`${variant}__newLayout`]]: newLayout && (!inline || !!variant),
    }),
    style: {
      ...{
        color: color ? `var(--${color})` : undefined,
        textAlign: center ? "center" : "",
      },
      ...style,
    },
    id,
    children,
    onClick,
  });
};

export default Typography;

/**
 * Tagged template literal that makes arguments medium pink.
 */
export const pinkText = (
  strings: TemplateStringsArray,
  ...pinkText: string[]
) =>
  strings.reduce(
    (elems, str, i) => (
      <>
        {elems}
        {str}
        {i < pinkText.length && (
          <span style={{ color: "var(--medium-pink)" }}>{pinkText[i]}</span>
        )}
      </>
    ),
    <></>
  );
